import React, { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { LogIn } from "lucide-react";
import { useAuth } from "../lib/auth";
import { apiError } from "../lib/api";
import { AuthCard, BigField, PasswordField, AuthError } from "../components/AuthUI";

export default function Login() {
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(true);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (!loading && user?.is_admin) {
    return <Navigate to={user.must_change_password ? "/estudio/cambiar-clave" : "/estudio"} replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const u = await login(email, password, remember);
      navigate(u.must_change_password ? "/estudio/cambiar-clave" : "/estudio", { replace: true });
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthCard title="Bendiciones, Pastor" subtitle="Ingresá con tu correo y tu contraseña." testId="login-page">
      <form onSubmit={submit} noValidate={false}>
        <AuthError message={error} />
        <BigField
          label="Correo electrónico" id="login-email" type="email" inputMode="email" autoComplete="username"
          autoCapitalize="none" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input"
        />
        <PasswordField label="Contraseña" id="login-password" value={password} onChange={(e) => setPassword(e.target.value)} testId="login-password-input" />
        <label className="flex items-center gap-4 mb-8 cursor-pointer select-none text-lg md:text-xl text-[#1B1C1A]" data-testid="login-remember-label">
          <input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} className="auth-check" data-testid="login-remember-checkbox" />
          Mantener la sesión iniciada
        </label>
        <button type="submit" disabled={busy} className="pill pill-primary auth-btn w-full" data-testid="login-submit-button">
          <LogIn size={24} /> {busy ? "Ingresando…" : "Ingresar"}
        </button>
      </form>
      <div className="text-center mt-8">
        <Link to="/estudio/olvide" className="text-lg md:text-xl font-semibold text-[#A36A00] underline underline-offset-4" data-testid="login-forgot-password-link">
          Olvidé mi contraseña
        </Link>
      </div>
    </AuthCard>
  );
}
